import InputCopy from 'components/atomic/atoms/input/input-copy'
import InputSearch from 'components/atomic/atoms/input/input-search'
import InputUrl from 'components/atomic/atoms/input/input-url'

import Input from './input'

export type { InputProps } from './input'

export { InputCopy, InputSearch, InputUrl }

export default Input
